<template lang="pug">
#app
  loading-overlay(:key="$route.fullPath" :visible="isLoading" v-if="shouldShowLoading")
  lang-navigation-eng(v-if="$route.name == 'English'")
  lang-navigation-jp(v-else-if="$route.name == 'Japanese'")
  navigation(v-else, @footerProductClick="footerProductClick")
  #main(
    :class="[$route.name == 'English' || $route.name == 'Japanese' ? 'padding_top_lang' : 'padding_top_main']"
  )
    transition(name="page", mode="out-in")
      router-view(:freshFlag="freshFlag")
  cookie(v-if="isCookieDisplay", @agreeClick="agreeClick")
  quick-menu.d-none.d-md-block(
    v-if="$route.name != 'English' && $route.name != 'Japanese'"
  )
  transition(name="page", mode="out-in")
    quick-menu-mobile.d-md-none(
      v-if="isQuickMenuMobileShow && $route.name != 'English' && $route.name != 'Japanese'"
    )
  go-top
  font-size-controls
</template>

<script>
import "@/assets/style/components.scss";
import "@/assets/style/main.scss";
import Navigation from "@/components/common/Navigation";
import LangNavigationEng from "@/components/eng/Navigation";
import LangNavigationJP from "@/components/jp/Navigation";
import Cookie from "@/components/common/Cookie";
import { getCookieAgree } from "@/utils/auth";
import QuickMenu from "@/components/common/QuickMenu";
import QuickMenuMobile from "@/components/common/QuickMenuMobile";
import GoTop from "@/components/common/GoTop";
import LoadingOverlay from '@/components/common/LoadingOverlay'
import FontSizeControls from '@/components/common/FontSizeControls'

export default {
  name: "App",
  components: {
    navigation: Navigation,
    "lang-navigation-eng": LangNavigationEng,
    "lang-navigation-jp": LangNavigationJP,
    cookie: Cookie,
    "quick-menu": QuickMenu,
    "quick-menu-mobile": QuickMenuMobile,
    "go-top": GoTop,
    "loading-overlay": LoadingOverlay,
    "font-size-controls": FontSizeControls
  },
  computed: {
    shouldShowLoading() {
      const hasMeta = this.$route.matched.some(r => r.meta && r.meta.showLoading)
      if (!hasMeta) return false
      // 僅在 /product/intro/1 顯示（其餘 intro 不顯示）
      if (this.$route.name === 'ProductIntro') {
        return String(this.$route.params.type || '') === '1'
      }
      // Customize 僅在 manager 與 onlineservice 顯示
      if (this.$route.name === 'Customize') {
        const p = String(this.$route.params.page || '')
        return p === 'manager' || p === 'onlineservice'
      }
      return true
    }
  },
  data() {
    return {
      isCookieDisplay: true,
      isQuickMenuMobileShow: true,
      oldScrollTop: 0, //上一次滾動距離
      scrollTop: 0, //目前距離
      screenWidth: document.documentElement.clientWidth, //螢幕寬度
      freshFlag: 0,
      width: 0,
      isLoading: false
    };
  },
  created() {
    this.cookieAgree();
  },
  methods: {
    startLoading() {
      this.isLoading = true
      // 最小 loading 顯示時間 + 確保畫面 render 後再關掉
      setTimeout(() => {
        this.$nextTick(() => {
          this.isLoading = false
        })
      }, 900);  // 確保 loading 顯示至少 900ms
    },
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    handleScroll() {
      window.addEventListener("scroll", () => {
        if (this.width < 768) {
          this.scrollTop = window.pageYOffset;
        }
      });
    },
    agreeClick() {
      this.cookieAgree();
    },
    cookieAgree() {
      if (getCookieAgree()) {
        this.isCookieDisplay = false;
      } else {
        this.isCookieDisplay = true;
      }
    },
    footerProductClick() {
      this.freshFlag = this.freshFlag + 1;
    },
  },
  mounted() {
    if (this.shouldShowLoading) this.startLoading();
    this.onResize();
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll");
  },
  watch: {
    $route() {
      if (this.shouldShowLoading) {
        this.startLoading(); // 僅在需要的路由顯示 loading
      } else {
        this.isLoading = false; // 切到不需要的頁面時，確保關閉
      }
    },
    "$store.state.screenWidth": function (width) {
      //監聽螢幕寬度變化
      var oIframe = document.getElementById("app");
      oIframe.style.width = Number(width) + "px";
    },
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.pageYOffset) {
          //滾動結束
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
          this.isQuickMenuMobileShow = true;
        }
      }, 100);
      if (this.oldScrollTop == oldValue) {
        //開始滾動
        this.isQuickMenuMobileShow = false;
      }
    },
  },
};
</script>

<style lang="scss">
.padding_top_main {
  padding-top: 90px;
}

.padding_top_lang {
  padding-top: 132px;
}

@media (max-width: 991px) {
  .padding_top_main {
    padding-top: 72px;
  }

  .padding_top_lang {
    padding-top: 76px;
  }
}

@media (max-width: 767px) {
  .padding_top_main {
    padding-top: 72px;
  }

  .padding_top_lang {
    padding-top: 72px;
  }
}

@media (max-width: 575px) {
  .padding_top_main {
    padding-top: 57px;
  }

  .padding_top_lang {
    padding-top: 57px;
  }
}

.loading-overlay {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
/*  以下為文字變化設定 */
body.font-small {
  --text-scale: 0.9;
}
body.font-medium {
  --text-scale: 1;
}
body.font-large {
  --text-scale: 1.15;
}

#main section h1 {
  font-size: calc(64px * var(--text-scale));
}
@media (max-width: 767px) {
  #main section h1 {
    font-size: calc(7.8125vw * var(--text-scale));
  }
  #main section > .container {
    padding-right: 5.2vw;
  }
}

#main #detail h1 {
  font-size: calc(36px * var(--text-scale));
}

#main .header_container h1,
#main h2,
#main h2.title {
  font-size: calc(28px * var(--text-scale));
}

#main h2.i_h2_title,
#main .summary .feature h5 {
  font-size: calc(28px * var(--text-scale));
}

#main h5,
#main h5 span{
  font-size: calc(16px * var(--text-scale));
}

#main h4,
#main .border_tab h5,
#main .content h5,
#main .long_text,
#main .info h3 {
  font-size: calc(22px * var(--text-scale));
}

#main .difference .feature h5,
#main .customer_service p,
#main h4.tw {
  font-size: calc(20px * var(--text-scale));
}

#main .content h5,
#main h4.eng {
  font-size: calc(20px * var(--text-scale));
}

#main p,
#main .btn_round,
#main .btn_square,
#main .i_h4,
#main .item span,
#main pre,
#main .card_expand_content a,
#main .breadcrumb li,
#main #detail .date,
#main .breadcrumb li,
#main #detail .content,
#main .i_body_l,
#main .i_body,
#main p.i_content,
#main .sub_title
{
  font-size: calc(18px * var(--text-scale));
}

#main .see_more_btn,
#main .contact_btn,
#main .collapse_btn,
#main h6,
#main .infos p,
#main p,
#main .page-item,
#main .date,
#main .tab h5 {
  font-size: calc(16px * var(--text-scale));
}

#main .selector_round_btn {
  font-size: calc(14px * var(--text-scale));
}
</style>
